module.exports = __webpack_public_path__ + "static/media/faq_list_black.b0950580.svg";